export enum EClusterData {
  Case = 'case',
  NewCase = 'newCase',
  OnGround = 'onGround',
  OnFly = 'onFly',
}
